var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c("div", { staticClass: "mobile-header fixed-top" }, [
      _c(
        "div",
        { staticClass: "float-left" },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _vm.sidebar
              ? _c(
                  "nav",
                  {
                    staticClass: "d-block d-md-block d-lg-none",
                    attrs: { id: "sidebar" }
                  },
                  [
                    _c("div", { staticClass: "sidebar-header" }, [
                      _c(
                        "a",
                        {
                          staticClass: "font-20 float-right closebtn",
                          on: {
                            click: function($event) {
                              return _vm.toggleToIcons()
                            }
                          }
                        },
                        [_vm._v("×")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { clear: "both" } }),
                    _vm._v(" "),
                    _c("ul", { staticClass: "list-unstyled" }, [
                      _c(
                        "li",
                        { staticClass: "active" },
                        [
                          _c("router-link", { attrs: { to: _vm.url } }, [
                            _c("i", { staticClass: "fa fa-home" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-item-name" }, [
                              _vm._v("Home")
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/view-tasklist" } },
                            [
                              _c("i", { staticClass: "fa fa-tasks" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "menu-item-name" }, [
                                _vm._v("Task Lists")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/task-library" } },
                            [
                              _c("i", { staticClass: "fa fa-book" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "menu-item-name" }, [
                                _vm._v("Task Library")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c("router-link", { attrs: { to: "/logout" } }, [
                            _c("i", { staticClass: "fa fa-sign-out" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-item-name" }, [
                              _vm._v("Sign Out")
                            ])
                          ])
                        ],
                        1
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "w-60 mt1",
            attrs: {
              src: require("@/assets/MM-logo.png"),
              alt: "MentorMentee"
            },
            on: { click: _vm.logoTapRedirect }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "float-right" },
        [
          _c(
            "div",
            [
              _c(
                "b-dropdown",
                {
                  staticClass: "m-md-2",
                  attrs: { id: "dropdown-1", text: _vm.first_name }
                },
                [
                  !this.$store.state.user_locations
                    .isUserLinkedMultipleLocations
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-dropdown-text",
                            [
                              _c("router-link", { attrs: { to: _vm.url } }, [
                                _c("span", { staticClass: "fa-icon-width" }, [
                                  _c("img", {
                                    staticClass: "menu_icon",
                                    attrs: {
                                      src: require("@/assets/manager/home_icon_dashboard_not_selected.png")
                                    }
                                  })
                                ]),
                                _vm._v(" Home")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          (_vm.isManager && !_vm.isEnterpriseAdmin) ||
                          (_vm.$store.state.switch_admin_username &&
                            !_vm.isEnterpriseAdmin)
                            ? _c(
                                "b-dropdown-text",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/admin-console" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fa-icon-width" },
                                        [
                                          _c("img", {
                                            staticClass: "menu_icon",
                                            attrs: {
                                              src: require("@/assets/manager/admin_console_not_selected.png")
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" Admin")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-text",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/myprofile" } },
                                [
                                  _c("span", { staticClass: "fa-icon-width" }, [
                                    _c("img", {
                                      staticClass: "menu_icon",
                                      attrs: {
                                        src: require("@/assets/manager/my_profile_menu_icon_not_selected.png")
                                      }
                                    })
                                  ]),
                                  _vm._v(" My Profile")
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          (_vm.isManager && !_vm.isEnterpriseAdmin) ||
                          (_vm.$store.state.switch_admin_username &&
                            !_vm.isEnterpriseAdmin) ||
                          _vm.isMentor ||
                          _vm.isMentee | _vm.isApprentice
                            ? _c(
                                "b-dropdown-text",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/my-badges" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fa-icon-width" },
                                        [
                                          _c("img", {
                                            staticClass: "menu_icon",
                                            attrs: {
                                              src: require("@/assets/manager/my_badges_menu_icon_not_selected.png")
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" My Badges")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-text",
                            [
                              _c("router-link", { attrs: { to: "/logout" } }, [
                                _c("span", { staticClass: "fa-icon-width" }, [
                                  _c("img", {
                                    staticClass: "menu_icon",
                                    attrs: {
                                      src: require("@/assets/manager/sign_out_menu_icon.png")
                                    }
                                  })
                                ]),
                                _vm._v(" Sign Out")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$store.state.switch_admin_username
                            ? _c("b-dropdown-text", [
                                _c("div", { staticClass: "switch_user" }, [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.switchUserLogout()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        { staticClass: "cursor-pointer" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "fa-icon-width" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-power-off",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            ]
                                          ),
                                          _vm._v(" Logout as Admin")
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.$store.state.user_locations.isUserLinkedMultipleLocations
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-dropdown-text",
                            [
                              _c("router-link", { attrs: { to: _vm.url } }, [
                                _c("span", { staticClass: "fa-icon-width" }, [
                                  _c("i", {
                                    staticClass: "fa fa-tachometer",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]),
                                _vm._v(" Dashboard")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isManager ||
                          _vm.$store.state.switch_admin_username
                            ? _c(
                                "b-dropdown-text",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/admin-console" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fa-icon-width" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-users",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" Admin")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isEnterpriseAdmin
                            ? _c(
                                "b-dropdown-text",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/myprofile" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fa-icon-width" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-user",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" My Profile")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEnterpriseAdmin
                            ? _c(
                                "b-dropdown-text",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/enterprise-admin/myprofile"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fa-icon-width" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-user",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" My Profile")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMentor
                            ? _c(
                                "b-dropdown-text",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/my-tasklists" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fa-icon-width" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-tasks",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" Task Lists")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMentee || _vm.isApprentice
                            ? _c(
                                "b-dropdown-text",
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/mentee-my-tasklists" } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fa-icon-width" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-tasks",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" Task Lists")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-text",
                            [
                              _c("router-link", { attrs: { to: "/logout" } }, [
                                _c("span", { staticClass: "fa-icon-width" }, [
                                  _c("i", {
                                    staticClass: "fa fa-arrow-circle-left",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]),
                                _vm._v(" Sign Out")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$store.state.switch_admin_username
                            ? _c("b-dropdown-text", [
                                _c("div", { staticClass: "switch_user" }, [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.switchUserLogout()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        { staticClass: "cursor-pointer" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "fa-icon-width" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-power-off",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            ]
                                          ),
                                          _vm._v(" Logout as Admin")
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.$store.state.user_locations.isUserLinkedMultipleLocations
                    ? _c("b-dropdown-text", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.switchToMentor,
                                expression: "switchToMentor"
                              }
                            ],
                            staticClass: "switch_user"
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.managerFlag,
                                    expression: "managerFlag"
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.switchUser("Manager")
                                  }
                                }
                              },
                              [
                                _c("a", { staticClass: "cursor-pointer" }, [
                                  _c("span", { staticClass: "fa-icon-width" }, [
                                    _c("i", {
                                      staticClass: "fa fa-exchange",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]),
                                  _vm._v(" Switch to Admin")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.mentorFlag,
                                    expression: "mentorFlag"
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.switchUser("Mentor")
                                  }
                                }
                              },
                              [
                                _c("a", { staticClass: "cursor-pointer" }, [
                                  _c("span", { staticClass: "fa-icon-width" }, [
                                    _c("i", {
                                      staticClass: "fa fa-exchange",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]),
                                  _vm._v(" Switch to Mentor")
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.switchToInstructor,
                                expression: "switchToInstructor"
                              }
                            ],
                            staticClass: "switch_user"
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.primaryadminFlag,
                                    expression: "primaryadminFlag"
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.switchUser("Primary Admin")
                                  }
                                }
                              },
                              [
                                _c("a", { staticClass: "cursor-pointer" }, [
                                  _c("span", { staticClass: "fa-icon-width" }, [
                                    _c("i", {
                                      staticClass: "fa fa-exchange",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]),
                                  _vm._v(" Switch to Admin")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.instructorFlag,
                                    expression: "instructorFlag"
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.switchUser("Instructor")
                                  }
                                }
                              },
                              [
                                _c("a", { staticClass: "cursor-pointer" }, [
                                  _c("span", { staticClass: "fa-icon-width" }, [
                                    _c("i", {
                                      staticClass: "fa fa-exchange",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]),
                                  _vm._v(" Switch to Instructor")
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.$store.state.user_locations.isUserLinkedMultipleLocations
                    ? _c(
                        "b-dropdown-text",
                        [
                          _c("b-dropdown-divider"),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: "collapse-buildable-submenu",
                                  expression: "'collapse-buildable-submenu'"
                                }
                              ],
                              staticClass: "cursor-pointer location-dd",
                              on: { click: _vm.showLocations }
                            },
                            [
                              _c("span", { staticClass: "fa-icon-width" }, [
                                _c("i", { staticClass: "fa fa-map-marker" })
                              ]),
                              _vm._v("Locations\n               "),
                              !_vm.isLocationListDisplay
                                ? _c("i", {
                                    staticClass:
                                      "fa fa-angle-down location_down_arrow"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isLocationListDisplay
                                ? _c("i", {
                                    staticClass:
                                      "fa fa-angle-up location_down_arrow"
                                  })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.$store.state.user_locations.isUserLinkedMultipleLocations
                    ? _c(
                        "b-collapse",
                        { attrs: { id: "collapse-buildable-submenu" } },
                        [
                          _c("b-dropdown-text", [
                            _c("a", { staticClass: "cursor-pointer" }, [
                              _c(
                                "div",
                                { staticClass: "float-left trim-text" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.currentLocation.accountName)
                                      )
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                     " +
                                      _vm._s(
                                        _vm.formatAddress(
                                          _vm.currentLocation.city,
                                          _vm.currentLocation.stateName
                                        )
                                      ) +
                                      "\n                   "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                { staticClass: "btn btn-sm currentBtn" },
                                [
                                  _vm._v(
                                    "\n                     Current\n                   "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-dropdown-text", [
                            _c("a", { staticClass: "cursor-pointer" }, [
                              _c(
                                "div",
                                { staticClass: "float-left trim-text" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.selectLocation.accountName)
                                      )
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                     " +
                                      _vm._s(
                                        _vm.formatAddress(
                                          _vm.selectLocation.city,
                                          _vm.selectLocation.stateName
                                        )
                                      ) +
                                      "\n                   "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm selectBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.setCurrentLocation(
                                        _vm.selectLocation
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                     Select\n                   "
                                  )
                                ]
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("LocationSwitchNotificationModal", {
            attrs: {
              isLocationSwitchNotificationModalVisible:
                _vm.isLocationSwitchNotificationModalVisible,
              userFullName: _vm.userFullName,
              notifyMessage: _vm.notifyMessage
            },
            on: { close: _vm.closeLocationSwitchNotificationModal }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47c717b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c717b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/user_menu.vue
// module id = null
// module chunks = 